export const VOUCHER_GENERATE_FLAG = {
  PENDING   : 'pending',
  COMPLETED : 'completed'
}
